import { render, staticRenderFns } from "./FormPart.vue?vue&type=template&id=10d8fd2a"
import script from "./FormPart.vue?vue&type=script&lang=ts"
export * from "./FormPart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports